import "fixed-data-table-2/dist/fixed-data-table.css";
import noFilesImg from "static/to_do_list_nothing.jpg";

import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Table, Column, Cell } from "fixed-data-table-2";
import { LinearProgress, Typography } from "@material-ui/core";
import { getSoloPhysNum } from "util/solo";

const formatBytes = bytes => {
  if (!bytes) return "-";
  if (bytes > 1e3 && bytes < 1e6) return `${Math.round(bytes / 1e3)} kB`;
  if (bytes > 1e6 && bytes < 1e9) return `${Math.round(bytes / 1e6)} MB`;
  if (bytes > 1e9 && bytes < 1e12) return `${Math.round(bytes / 1e9)} GB`;
  return `${bytes} B`;
};

const FilesListTable = props => {
  if (props.soloConfirmFilesFetching) {
    return <LinearProgress />;
  }
  if (props.soloConfirmFilesList.length === 0) {
    return <img src={noFilesImg} alt="no annotated files to review" />;
  }

  const styles = {
    headerStyle: {
      marginTop: 5,
      fontWeight: "bold"
    }
  };

  return (
    <Table
      rowsCount={props.soloConfirmFilesList.length}
      rowHeight={30}
      headerHeight={30}
      width={props.width}
      height={
        ((props.soloConfirmFilesList.length > 10
          ? 10
          : props.soloConfirmFilesList.length) +
          1) *
          30 +
        2
      }
      onRowClick={props.onFilesTableRowSelect}
    >
      <Column
        cell={({ rowIndex, ...colProps }) => {
          const soloData = props.soloConfirmFilesList[rowIndex];
          return (
            <Cell {...colProps}>
              <input
                type="checkbox"
                checked={props.soloFilesBeingConfirmed.includes(
                  soloData.soloFilePk
                )}
                onChange={() => {}} // Do default row select
              />
            </Cell>
          );
        }}
        width={40}
      />
      <Column
        header={
          <Typography style={styles.headerStyle}>Annotation date</Typography>
        }
        cell={({ rowIndex, ...colProps }) => {
          const soloData = props.soloConfirmFilesList[rowIndex];
          if (!soloData.annotatedDate) return <Cell {...colProps}>-</Cell>;
          const dt = moment(soloData.annotatedDate);
          return (
            <Cell {...colProps} title={dt.format()}>
              <Typography>{dt.format("lll")}</Typography>
            </Cell>
          );
        }}
        width={125}
        flexGrow={1}
      />
      <Column
        header={<Typography style={styles.headerStyle}>Survey date</Typography>}
        cell={({ rowIndex, ...colProps }) => {
          const dt = moment(props.soloConfirmFilesList[rowIndex].collectionDt);
          return (
            <Cell {...colProps} title={dt.format()}>
              <Typography>{dt.format("ll")}</Typography>
            </Cell>
          );
        }}
        width={125}
        flexGrow={1}
      />
      <Column
        header={<Typography style={styles.headerStyle}>Solo number</Typography>}
        cell={({ rowIndex, ...colProps }) => {
          const soloData = props.soloConfirmFilesList[rowIndex];
          return (
            <Cell {...colProps}>
              <Typography>
                {getSoloPhysNum(soloData.deviceSn, props.soloUIDLookup)}
              </Typography>
            </Cell>
          );
        }}
        width={100}
        flexGrow={1}
      />
      <Column
        header={<Typography style={styles.headerStyle}>Casts</Typography>}
        cell={({ rowIndex, ...colProps }) => {
          const soloData = props.soloConfirmFilesList[rowIndex];
          return (
            <Cell {...colProps}>
              <Typography>{soloData.numCasts}</Typography>
            </Cell>
          );
        }}
        width={100}
        flexGrow={1}
      />
      <Column
        header={<Typography style={styles.headerStyle}>Filename</Typography>}
        cell={({ rowIndex, ...colProps }) => {
          const soloData = props.soloConfirmFilesList[rowIndex];
          return (
            <Cell {...colProps}>
              <Typography>{soloData.filename}</Typography>
            </Cell>
          );
        }}
        width={200}
        flexGrow={1}
      />
      <Column
        header={<Typography style={styles.headerStyle}>File size</Typography>}
        cell={({ rowIndex, ...colProps }) => (
          <Cell {...colProps}>
            <Typography>
              {formatBytes(props.soloConfirmFilesList[rowIndex].fileBytes)}
            </Typography>
          </Cell>
        )}
        width={30}
        flexGrow={1}
      />
    </Table>
  );
};

FilesListTable.propTypes = {
  width: PropTypes.number,
  soloConfirmFilesFetching: PropTypes.bool.isRequired,
  soloFilesBeingConfirmed: PropTypes.arrayOf(PropTypes.number),
  soloConfirmFilesList: PropTypes.arrayOf(
    PropTypes.shape({
      soloFilePk: PropTypes.number.isRequired,
      collectionDt: PropTypes.string,
      filename: PropTypes.string.isRequired,
      numCasts: PropTypes.number,
      annotatedDate: PropTypes.string,
      fileBytes: PropTypes.number,
      deviceSn: PropTypes.string
    })
  ).isRequired,
  onFilesTableRowSelect: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  soloUIDLookup: PropTypes.object.isRequired
};

FilesListTable.defaultProps = {
  soloFilesBeingConfirmed: [],
  width: 900
};

export default FilesListTable;
